import React from "react";
import "./index.css";

export const PostShower = props => {
  return <div className="post-shower-content">{props.children}</div>;
};
